export default __webpack_public_path__ + "static/media/sand.d7b9a806.png";